module.exports = __webpack_public_path__ + "static/media/logo-parma-infanzia-bianco-150.7386cf9a.png";